var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("恭喜你！")]),_vm._v(" "),_c('h2',[_vm._v("付款成功，立即预约！")]),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('div',{staticClass:"no",on:{"click":_vm.gohome}},[_vm._v("暂不预约")]),_vm._v(" "),_c('div',{staticClass:"yes",on:{"click":_vm.yuyue}},[_vm._v("立即预约")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52e075ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/paySuccess.vue
// module id = null
// module chunks = 